// extracted by mini-css-extract-plugin
module.exports = {"hiddenDiv":"HiddenDiv_hiddenDiv__1t6hq"};